import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { formatPrice } from "../../utils/common";
import * as queryString from "query-string";

import styles from "./wallet.module.scss";

interface Props {
  data: any;
  handleChangePaymentMethod: any;
  selectedPaymentMethod: any;
}
const PaymentMethodItem: React.FC<Props> = ({
  data,
  handleChangePaymentMethod,
  selectedPaymentMethod,
}) => {
  const { t, i18n } = useTranslation(["common", "notification", "wallet"]);
  const { pathname, search } = useLocation();

  const paymentFeeDisplay = () => {
    const parseQuery: any = queryString.parse(search);
    if (parseQuery.amount) {
      let percen: any;
      for (let i = 0; i < data?.markup.length; i++) {
        if (data?.markup[i].type === "TOPUP") {
          percen = data?.markup[i].percentage;
          break;
        }
      }
      return Math.ceil((parseQuery.amount * percen) / 100);
    }
    return 0;
  };

  const renderTextPaymentMethod = (value: string) => {
    let text = "";
    if (queryString.parse(search)?.lang) {
      text = value + "_" + queryString.parse(search)?.lang;
    } else {
      text = value + "_" + i18n.language;
    }
    return text;
  };

  return (
    <div className={styles.formPay__option__group}>
      <div className={styles.radio}>
        <input
          onChange={() => handleChangePaymentMethod(data?.payment_method)}
          checked={selectedPaymentMethod === data?.payment_method}
          value={data?.payment_method}
          type="radio"
          id={`payment_${data?.id}`}
          name="radio"
        />
        <label htmlFor={`payment_${data?.id}`}>
          <div className={styles.radio__icon}>
            <img src={data?.logo} alt="" />
          </div>
          <div className={styles.radio__text}>
            <p>{data?.[renderTextPaymentMethod("name")]}</p>
            <span className="my-6 block">
              {data?.[renderTextPaymentMethod("short_desc")]}
            </span>
            <div className="flex items-center gap-4">
              {t("common:Phí thanh toán")}:{" "}
              <span className="!text-red-primary font-medium">
                {formatPrice(data?.final_fee)}đ
              </span>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};
export default PaymentMethodItem;
